<app-split-container>
  <div slot="left">
    <opac-button class="back-button" [ariaLabel]="'general.back' | translate" [opacTooltip]="'general.back' | translate" (click)="loadLogin()">
      <opac-icon icon="navigate_back" slot="only-icon"></opac-icon>
    </opac-button>

    <app-login-dialog-image
      *ngIf="!customMessage()"
      [title]="'login.screens.forgotPassword.infoTitle' | translate"
      [subtitle]="'login.screens.forgotPassword.infoSubtitle' | translate"
    >
      <app-forgot-password-image></app-forgot-password-image>
    </app-login-dialog-image>

    <div *ngIf="customMessage()" class="custom-message" [innerHTML]="customMessage() | safe"></div>
  </div>

  <div slot="right">
    <form id="forgot-password-form" [formGroup]="form" (submit)="recoverPassword($event)">
      <opac-text-input formControlName="identifier">{{ forgotPasswordInputLabel() | translate }}</opac-text-input>
      <opac-button actionType="submit" form="forgot-password-form" [disabled]="form.invalid">{{ 'general.submit' | translate }}</opac-button>
    </form>
  </div>
</app-split-container>
